import styled from "@emotion/styled"
import { Badge } from "@chakra-ui/react"
import React from "react"
import { Box, Chip, Tooltip, ClickAwayListener, InfoIcon, Theme } from "@carrotfertility/carotene-core"

/**
 * @deprecated Do not use this component. Use carotene-core Chip instead.
 */
export const LegacyChip = styled(Badge)`
  background: #fdf5b0;
  padding: 4px;
  border-radius: 4px;
`
export enum ChipType {
  CHECKED_IN = "Checked in",
  SENSITIVE_SCENARIO = "Sensitive scenario",
  NO_PLAN = "No plan",
  NO_PLAN_NEEDED = "No plan needed",
  CHANGED_JOURNEY = "Journey changed",
  SKIPPED_MEDICAL_QUESTIONS = "Skipped medical questions",
  REPUBLISHED = "Republished"
}

const chipWithTooltipContent: Partial<Record<ChipType, string>> = {
  [ChipType.CHECKED_IN]:
    "Member completed the check-in flow, an abridged version of routing. Answers can be found in their “Latest routing answers.”",
  [ChipType.SENSITIVE_SCENARIO]: "Member indicated their journey is not going as planned during the check-in flow.",
  [ChipType.NO_PLAN]: "There is currently no Carrot Plan associated with the latest routing answers.",
  [ChipType.NO_PLAN_NEEDED]:
    "Member indicated their journey is not going as planned during the check-in flow and they do not want a Carrot Plan refresh at this time."
}

export const ChipWithTooltip = ({
  type,
  backgroundColor
}: {
  type: ChipType
  backgroundColor?: (theme: Theme) => string
}): JSX.Element => {
  const [open, setOpen] = React.useState(false)
  const tooltipContent = chipWithTooltipContent[type]

  const customChipStyles = {
    backgroundColor: backgroundColor,
    "&:hover, &:active, &:focus": {
      backgroundColor: backgroundColor,
      boxShadow: "none"
    }
  }

  return (
    <>
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <Tooltip title={tooltipContent} open={open} onClose={() => setOpen(false)} id="tooltip-content">
          <Chip
            onClick={() => setOpen(!open)}
            sx={customChipStyles}
            aria-describedby={open ? "tooltip-content" : undefined}
            label={
              <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                {type}
                &nbsp;
                <InfoIcon color="inherit" fontSize="inherit" />
              </Box>
            }
          />
        </Tooltip>
      </ClickAwayListener>
    </>
  )
}
